import { UniversalContext, useUniversalContext } from "@cxc/react-universal-components";
import { useEffect } from "react";
import useSWR, { Fetcher } from "swr";
import { ApiCall, CallStatus, PageCalls } from "../../types/apiTypes";

const useApiClient = (path: string, fetcher: Fetcher, pageKey: string) => {
  const { setScopedValue, subscribeScopedValue } = useUniversalContext() as UniversalContext;
  const pageCalls = subscribeScopedValue("PST", pageKey) as PageCalls;

  if (!pageCalls) {
    setScopedValue("PST", pageKey, []);
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment
  const { data, error, isLoading } = useSWR(path, fetcher, {
    keepPreviousData: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshInterval: 600000, // 10 minutes to invalidate cache
    onErrorRetry: (_error, _key, _config, revalidate, { retryCount }) => {
      if (retryCount >= 4) {
        setContext(path, "error", pageCalls, setScopedValue, pageKey);
        return;
      }
      setContext(path, "loading", pageCalls, setScopedValue, pageKey);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return
      setTimeout(() => revalidate({ retryCount }), 500);
    },
    onSuccess: () => {
      setContext(path, "success", pageCalls, setScopedValue, pageKey);
    }
  });

  useEffect(() => {
    if (isLoading) {
      setContext(path, "loading", pageCalls, setScopedValue, pageKey);
    }
  }, [isLoading]);

  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    data,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    isLoading,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    error
  };
};

const setContext = (
  path: string,
  status: CallStatus,
  pageCalls: PageCalls,
  setScopedValue: (
    scope: string,
    key: string,
    value: ApiCall[]
  ) => void,
  pageKey: string
) => {
  const newPageCalls = JSON.parse(JSON.stringify(pageCalls)) as PageCalls || [] as PageCalls;
  let pageCall = newPageCalls?.find((call: ApiCall) => call.path === path);
  if (!pageCall) {
    pageCall = { path: path, status: status };
    newPageCalls.push(pageCall);
  }
  pageCall.status = status;
  setScopedValue("PST", pageKey, newPageCalls);
};

export default useApiClient;
